import { RouteRecordRaw } from 'vue-router'

const productionInspection: Array<RouteRecordRaw> = [
    {
        path: '/productionInspection',
        name: 'productionInspection',
        redirect: '/productionInspection/index',
        component: () => import('@/views/children.vue'),
        children: [
            {
                path: '/productionInspection/index',
                name: 'exWarehouse',
                meta: {
                    title: '品质检验记录',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/index.vue')
            },
            {
                path: '/productionInspection/details',
                name: 'details',
                meta: {
                    title: '检验详情',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/details.vue')
            },
            {
                path: '/productionInspection/test',
                name: 'test',
                meta: {
                    title: '品质检验',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/test.vue')
            },
            {
                path: '/productionInspection/finalInspection',
                name: 'finalInspection',
                meta: {
                    title: '品质终检',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/finalInspection.vue')
            },
            {
                path: '/productionInspection/finalInspectionRecord',
                name: 'finalInspectionRecord',
                meta: {
                    title: '品质终检记录',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/finalInspectionRecord.vue')
            },
            {
                path: '/productionInspection/finalInspectionDetails',
                name: 'finalInspectionDetails',
                meta: {
                    title: '终检详情',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/finalInspectionDetails.vue')
            },
            {
                path: '/productionInspection/equipmentInspection',
                name: 'equipmentInspection',
                meta: {
                    title: '设备巡检',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/equipmentInspection.vue')
            },
            {
                path: '/productionInspection/manualInspection',
                name: 'manualInspection',
                meta: {
                    title: '巡线',
                    keepAlive: true
                },
                component: () => import('@/views/productionInspection/manualInspection.vue')
            },
            {
                path: '/productionInspection/manualInspection1',
                name: 'manualInspection1',
                meta: {
                    title: '巡检',
                    keepAlive: true
                },
                component: () => import('@/views/productionInspection/manualInspection1.vue')
            },
            {
                path: '/productionInspection/manualInspection2',
                name: 'manualInspection2',
                meta: {
                    title: '完工检',
                    keepAlive: true
                },
                component: () => import('@/views/productionInspection/manualInspection2.vue')
            },
            {
                path: '/productionInspection/selectWorkOrder',
                name: 'selectWorkOrder',
                meta: {
                    title: '选择工单',
                    keepAlive: false
                },
                component: () => import('@/views/productionInspection/selectWorkOrder.vue')
            }
        ]
    }
]

export default productionInspection
